<template>
    <div class="v-atlas-map-modules-list">

        <div v-for="module in mapModulesProcessed" :key="module.uuid">

            <h3>
                <button :disabled="module.moduleConfig.hideSettingsPanel" @click="module.onModuleListEntryClicked()"
                    data-tooltip="Moduleinstellungen öffnen">
                    <div> {{ module.moduleConfig.title }}</div>
                </button>
            </h3>


            <div class="v-atlas-map-modules-list__module-standard-settings">
                <!--
                <label><span>Deckkraft:</span></label>
                -->
                <SmartButton v-model="module.visible" boolean class="v-atlas-map-modules-list__visibility-toggle"
                    :data-visible="module.visible" :data-tooltip="module.visible ? `${module.moduleConfig.title} ausblenden` : `${module.moduleConfig.title} einblenden`
                        ">
                </SmartButton>

                <SmartRangeInput data-help="map-module-opacity-slider" v-model="module.opacity" :min="0" :max="1"
                    :step="0.05" :show-labels="false" :tooltip-func="() => `Deckkraft: ${module.opacity}`" />

                <!--
                <button @click="onModuleInfoButtonClick(module)" class="v-atlas-map-modules-list__module-info-button"
                    data-tooltip="Modul-Informationen anzeigen"></button>
-->
                <!--
                <button v-if="!(module.moduleConfig.hideSettingsPanel)" @click=" module.onModuleListEntryClicked()"
                    class="v-atlas-map-modules-list__module-settings-button"
                    data-tooltip="Modul-Einstellungen öffnen"></button>
-->

            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import { AtlasMapModule } from "@/mapModules/AtlasMapModule";
import { MapModuleViewStackItem } from "@/MapModuleViewStackItem";
import { sidebarPanelNames } from "@/sidebarPanelNames";
import { sidebarPanelRoles } from "@/sidebarPanelRoles";
import { SmartButton, SmartRangeInput, ViewStackController } from "gertrud";
import { computed } from "vue";



const props = defineProps<{
    mapModules: AtlasMapModule[],
    vsc: ViewStackController
}>()



const mapModulesProcessed = computed(() => {
    return [...props.mapModules].reverse()
})

function onModuleInfoButtonClick(module: AtlasMapModule) {

    const item: MapModuleViewStackItem = {
        componentName: sidebarPanelNames.MAP_MODULE_INFO,
        props: {
            mapModule: module,
        },
        role: sidebarPanelRoles.MAP_MODULE_INFO,
        id: sidebarPanelRoles.MAP_MODULE_INFO,
        title: `Über das Kartenmodul '${module.moduleConfig.title}'`
    }

    props.vsc.addItem(item)

}
</script>
